import { pushEventInfo } from '../analytics';
export var catchRescheduleButtonAnalytics = function (fulfillmentType) {
    var setting = '';
    if (fulfillmentType === 'DFS') {
        setting = 'dfs reschedule button displayed';
    }
    if (fulfillmentType === 'BuyOnlineDeliverFromStore') {
        setting = 'bodfs reschedule button displayed';
    }
    if (fulfillmentType === 'Appliance') {
        setting = 'major appliance reschedule button displayed';
    }
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: { settings: setting },
    });
};
export var catchRescheduleModalOpen = function (fulfillmentType) {
    var setting = '';
    if (fulfillmentType === 'DFS') {
        setting = 'dfs reschedule calander';
    }
    if (fulfillmentType === 'BuyOnlineDeliverFromStore') {
        setting = 'bodfs reschedule calendar';
    }
    if (fulfillmentType === 'Appliance') {
        setting = 'major appliance reschedule calander';
    }
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: setting },
    });
};
export var catchApplyRescheduleSuccessAnalytics = function (fulfillmentType, daySlotsList) {
    var _a, _b;
    var setting = '';
    if (fulfillmentType === 'DFS') {
        setting = 'dfs reschedule success';
    }
    if (fulfillmentType === 'BuyOnlineDeliverFromStore') {
        if ((daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) &&
            ((_a = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
            ((_b = daySlotsList === null || daySlotsList === void 0 ? void 0 : daySlotsList.slotList) === null || _b === void 0 ? void 0 : _b[0].type) !== 'All Day') {
            setting = 'bodfs reschedule: premium time window selected: save changes';
        }
        else {
            setting = 'bodfs reschedule success';
        }
    }
    if (fulfillmentType === 'Appliance') {
        setting = 'major appliance reschedule success';
    }
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: { settings: setting },
    });
};
export var catchApplyRescheduleFailAnalytics = function (fulfillmentType) {
    var setting = '';
    if (fulfillmentType === 'DFS') {
        setting = 'dfs reschedule error';
    }
    if (fulfillmentType === 'BuyOnlineDeliverFromStore') {
        setting = 'bodfs reschedule error';
    }
    if (fulfillmentType === 'Appliance') {
        setting = 'major appliance reschedule error';
    }
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: { settings: setting },
    });
};
// Premium Time Window analytics
export var catchReschedulePremiumModalOpen = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: 'bodfs premium reschedule calendar' },
    });
};
export var catchReschedulePremiumSubmit = function () {
    pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: 'my account settings' },
        myAccount: {
            settings: 'bodfs reschedule: premium time window selected: save changes',
        },
    });
};
